import { render, staticRenderFns } from "./PlanPopup.vue?vue&type=template&id=fbc0b64e"
import script from "./PlanPopup.vue?vue&type=script&lang=js"
export * from "./PlanPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports